import { Box } from '@ff-it/ui';
import { TextField } from '@ff-it/form';
import { ActivityField } from 'components/fields/ActivityField';
import { CategoryField } from 'modules/supplier/category/MediaCategoryField';
import type { ReactNode } from 'react';
import type { ActivityKind } from 'types';

export type DiscountRuleConditionsProps = {
  activityKind: ActivityKind;
  activityLabel?: string;
  categoryLabel?: string;
  termsHelp?: ReactNode;
};

/** Conditions common to provider and client discount rules. */
export function DiscountRuleConditions({
  activityKind,
  activityLabel = 'Activity',
  categoryLabel = 'Category',
  termsHelp,
}: DiscountRuleConditionsProps) {
  const menuPortalTarget = typeof document === 'undefined' ? undefined : document.body;
  return (
    <>
      <ActivityField
        className="mb-0"
        name="target_activity"
        parse={(value) => value ?? null}
        label={activityLabel}
        size="sm"
        isClearable
        placeholder="Any activity"
        kind={activityKind}
        menuPortalTarget={menuPortalTarget}
        menuPosition="fixed"
      />
      <CategoryField
        className="mb-0"
        name="target_category"
        parse={(value) => value ?? null}
        label={categoryLabel}
        size="sm"
        isClearable
        placeholder="Any category"
        menuPortalTarget={menuPortalTarget}
        menuPosition="fixed"
      />
      <TextField
        className="mb-0"
        name="terms"
        parse={(value) => value ?? ''}
        label="Terms / comment"
        size="sm"
        multiline
        rows={2}
      />
      {termsHelp && (
        <Box textSize="xs" color="secondary">
          {termsHelp}
        </Box>
      )}
    </>
  );
}
